import type mapboxgl from "mapbox-gl";

import { LayerIds, type MapboxStyleLayer } from "fond/types";

const crossingFilter = ["==", ["get", "user_Crossing"], "YES"];

const pointLayout: mapboxgl.SymbolLayout = {
  "text-field": "\uF096",
  "text-font": ["fontello Regular"],
  "text-allow-overlap": true,
  "text-ignore-placement": true,
  "text-anchor": "bottom",
  "text-justify": "center",
  "text-line-height": -0.45,
  "text-padding": 0,
  "text-rotate": 0.01,
  "text-size": ["interpolate", ["linear"], ["zoom"], 10, 0, 18, 14],
  visibility: "visible",
};

const getPointPaintStyle = (color: string): mapboxgl.SymbolPaint => ({
  "text-color": "#000",
  "text-halo-width": 2,
  "text-halo-color": color,
});

export const inStreetPointsStyles: MapboxStyleLayer[] = [
  {
    id: "prefer-path-point",
    type: "symbol",
    filter: [
      "all",
      ["==", ["geometry-type"], "Point"],
      ["<", ["get", "user_CostFactor"], 1],
      ["==", ["get", "user_layerId"], LayerIds.inStreetPoints],
    ],
    layout: pointLayout,
    paint: {
      ...getPointPaintStyle("#00FF00"),
    },
  },
  {
    id: "avoid-path-point",
    type: "symbol",
    filter: [
      "all",
      ["==", ["geometry-type"], "Point"],
      [">", ["get", "user_CostFactor"], 1],
      ["==", ["get", "user_layerId"], LayerIds.inStreetPoints],
    ],
    layout: pointLayout,
    paint: {
      ...getPointPaintStyle("#FF0000"),
    },
  },
  {
    id: "neutral-path-point",
    type: "symbol",
    filter: [
      "all",
      ["==", ["geometry-type"], "Point"],
      ["any", ["==", ["get", "user_CostFactor"], 1], ["==", ["get", "user_CostFactor"], null]],
      ["==", ["get", "user_layerId"], LayerIds.inStreetPoints],
    ],
    layout: pointLayout,
    paint: {
      ...getPointPaintStyle("#AAA"),
    },
  },
];

export const inStreetStyles: MapboxStyleLayer[] = [
  {
    id: "prefer-path-line",
    type: "line",
    filter: [
      "all",
      ["==", ["geometry-type"], "LineString"],
      ["<", ["get", "user_CostFactor"], 1],
      ["==", ["get", "user_layerId"], LayerIds.inStreet],
    ],
    paint: {
      "line-color": "#00FF00",
      "line-width": ["case", crossingFilter, 2, 4],
    },
  },
  {
    id: "avoid-path-line",
    type: "line",
    filter: [
      "all",
      ["==", ["geometry-type"], "LineString"],
      [">", ["get", "user_CostFactor"], 1],
      ["==", ["get", "user_layerId"], LayerIds.inStreet],
    ],
    paint: {
      "line-color": "#FF0000",
      "line-width": ["case", crossingFilter, 2, 4],
    },
  },
  {
    id: "neutral-path-line",
    type: "line",
    filter: [
      "all",
      ["==", ["geometry-type"], "LineString"],
      ["any", ["==", ["get", "user_CostFactor"], 1], ["==", ["get", "user_CostFactor"], null]],
      ["==", ["get", "user_layerId"], LayerIds.inStreet],
    ],
    paint: {
      "line-color": "#AAA",
      "line-width": ["case", crossingFilter, 2, 4],
    },
  },
  {
    id: "gl-draw-line-active",
    type: "line",
    filter: ["all", ["==", "$type", "LineString"], ["==", "active", "true"]],
    paint: {
      "line-color": "rgb(33, 150, 243)",
      "line-opacity": 0.5,
      "line-width": 10,
    },
  },
];
